import { StepProps } from '@betterment/js-runtime';
import { Box, Button, CenteredWorkflowLayout, Flex, Text, WorkflowHeader } from '@betterment/style-closet-react';
import styled from '@emotion/styled';

import { CustomerSignupValues } from './Controller';

import { trackClick } from '../features/track';
import WalletImage from '../images/Wallet.png';
import CenteredImageContainer from '../Shared/components/CenteredImageContainer';
import Footer from '../Shared/components/Footer';

const OrderedListWithoutNumbers = styled.ol`
  list-style-type: none;
  padding: 0;
`;

const BeginSetup: React.FC<React.PropsWithChildren<StepProps<CustomerSignupValues>>> = ({
  flowState,
  goToNextStep,
}) => {
  const { stepTitle } = flowState.values;

  return (
    <Flex flexDirection={['column', 'row']}>
      <Flex width={[1, 2 / 5]} backgroundColor="bmtGrey20" flexDirection={['column', 'row']}>
        <Box display={['block', 'none']} px={[6, 0]}>
          <WorkflowHeader title={stepTitle} />
        </Box>
        <CenteredImageContainer maxHeight={['24rem', '50rem']} height={['24rem', '100%']} mt={[0, '15rem']}>
          <img height="100%" src={WalletImage} alt="Wallet" />
        </CenteredImageContainer>
      </Flex>
      <Box width={[1, 3 / 5]}>
        <CenteredWorkflowLayout variant="six-column">
          <CenteredWorkflowLayout.Slot name="header">
            <Box display={['none', 'block']}>
              <WorkflowHeader title={stepTitle} />
            </Box>
          </CenteredWorkflowLayout.Slot>
          <CenteredWorkflowLayout.Slot name="content">
            <Box mt={[0, '9.5rem']}>
              <Text as="p" color="bmtGrey60" fontSize={[2, 4]} lineHeight={[2, 4]}>
                Your Checking account has been created. Now, let's finish setting up your account.
              </Text>
              <OrderedListWithoutNumbers>
                {['Basic info', 'Financial profile', 'Identity check', 'Account setup'].map((stepName, index) => (
                  <Box py="4" pr="4" key={stepName} as="li" color={index === 3 ? 'bmtGrey90' : 'bmtGrey50'}>
                    <Text as="p" fontWeight={index === 3 ? 'bold' : 'normal'} data-testid="account-setup-step">
                      {index + 1}.&nbsp;
                      {stepName}
                    </Text>
                  </Box>
                ))}
              </OrderedListWithoutNumbers>
              <CenteredWorkflowLayout.Actions>
                <Button
                  onClick={() => {
                    trackClick({ name: 'Continue' });
                    goToNextStep();
                  }}
                >
                  Continue
                </Button>
              </CenteredWorkflowLayout.Actions>
            </Box>
          </CenteredWorkflowLayout.Slot>
          <CenteredWorkflowLayout.Slot name="footer">
            <Footer />
          </CenteredWorkflowLayout.Slot>
        </CenteredWorkflowLayout>
      </Box>
    </Flex>
  );
};

export default BeginSetup;
